import * as yup from 'yup';

import Required from 'enums/schemas/required.enum';

const AdCopyFormSchema = yup.object().shape({
  copy: yup.string().required(Required.Name),
});

export default AdCopyFormSchema;
